import { Element } from '../../equipment/models/elements/element';
import { Equipment } from '../../equipment/models/equipment';
import { PalletElement } from '../models/elements/palletElement';
import { ShelfElement } from '../models/elements/shelfElement';
import { Utils } from '../../core/services/utils.service';

const NESTED_KEY: RegExp = /^(default|\d+)$/;

function isPlainObject(value: unknown): value is Record<string, unknown> {
	return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function isNestedDataMap(raw: Record<string, unknown>): boolean {
	const keys: Array<string> = Object.keys(raw);

	return keys.length > 0 && keys.every((key: string) => NESTED_KEY.test(key) && isPlainObject(raw[key]));
}

export function resolveProductDataObject(
	raw: unknown,
	element: Element,
	stand: Equipment
): Record<string, unknown> {
	if (!isPlainObject(raw) || !Object.keys(raw).length) {
		return {};
	}

	if (!isNestedDataMap(raw)) {
		return { ...raw };
	}

	const shelfKey: string = element.is(ShelfElement, PalletElement)
		? Utils.getElementIndex(element, stand).toString()
		: 'default';
	const resolved: unknown = raw[shelfKey] || raw['default'];

	return isPlainObject(resolved) ? { ...resolved } : {};
}
